<template>
  <div>
    <div :classes="innerClasses" class="grid fuel-utilization__work-order" @click="handleClick($event, workOrder.work_order__id)" v-on:mouseleave="hideComment">
      <div class="grid fuel-utilization-wo__details">
        <div class="grid__col--9">
          <div class="fuel-utilization-wo__title" v-cloak>
            FM{{ workOrder.work_order_id }} - {{ workOrder.title }}
          </div>

          <div class="fuel-utilization-wo__dates">
            <span class="h-italic-text">Created - {{ workOrder.created }}</span>
            <span v-if="workOrder.completed"> |
              <span class="fuel-utilization-wo__glyph--completed glyphicon glyphicon-ok-sign" aria-hidden="true"></span>
            </span>
            <span class="h-italic-text" v-if="workOrder.completed">{{ workOrder.completed }}</span>
          </div>
          <div class="fuel-utilization-wo__description is-displayed-mobile" v-html="workOrder.details"></div>
        </div>
        <div class="grid__col--2 h-right-align h-no-right-pad is-hidden-mobile">
          <div class="fuel-utilization-wo__hours-worked">Hours worked:</div>
        </div>
        <div class="grid__col--1 h-center-align h-no-left-pad h-no-margin is-hidden-mobile">
          <div class="fuel-utilization-wo__hours">{{ workOrder.timeSpent }}</div>
        </div>
      </div>
      <div class="grid">
        <div class="fuel-utilization-wo__description is-hidden-mobile" v-html="workOrder.details"></div>
      </div>
      <div class="fuel-utilization-wo__hours-worked-container is-displayed-mobile">
        <div class="fuel-utilization-wo__hours-worked-module">
          <div class="fuel-utilization-wo__hours-worked-module-content fuel-utilization-wo__hours-worked h-right-align">
            <div class="fuel-utilization-wo__hours fuel-utilization-wo__hours--label h-display-inline-block">Hours worked: </div>
            <div class="fuel-utilization-wo__hours fuel-utilization-wo__hours--value h-display-inline-block">{{ workOrder.timeSpent }}</div>
          </div>
        </div>
        <div class="fuel-utilization-wo__hours-worked-module">
          <div class="fuel-utilization-wo__hours-worked-module-content fuel-utilization-wo__status">{{ workOrder.portalStatus }}</div>
        </div>
      </div>
      <div class="grid">
        <div class="fuel-utilization-wo__dimension-tags">
          <div v-if="workOrder.department" :class="['fuel-utilization-wo__dimension', 'fuel-utilization-wo__dimension--department', 'fuel-utilization-wo__dimension--department--' +  slug(workOrder.department)]" v-cloak>
            {{ workOrder.department }}
          </div>
          <div v-if="workOrder.specialty" :class="['fuel-utilization-wo__dimension', 'fuel-utilization-wo__dimension--specialty', 'fuel-utilization-wo__dimension--specialty--' + workOrder.specialty]" v-cloak>
            {{ workOrder.specialty }}
          </div>
          <div v-if="workOrder.objective" :class="['fuel-utilization-wo__dimension', 'fuel-utilization-wo__dimension--objective', 'fuel-utilization-wo__dimension--objective--' + workOrder.objective]" v-cloak>
            {{ workOrder.objective }}
          </div>
          <div v-if="workOrder.status" :class="['fuel-utilization-wo__dimension', 'fuel-utilization-wo__dimension--status', 'is-hidden-mobile']" v-cloak>
            {{ ucfirst(workOrder.status) }}
          </div>
        </div>
      </div>
    </div>
    <div class="wo-divider--dots" v-if="divider"><span class="glyphicon glyphicon-option-horizontal" aria-hidden="true"></span></div>
  </div>
</template>

<script>
  import lodash from 'lodash';

  export default {
    name: 'WorkOrderSummary',
    props: {
      workOrder: {
        type: Object,
        required: true
      },
      divider: {
        type: Boolean,
        default: false
      },
      classes: {
        type: Array,
        default: function () { return [] }
      }
    },
    data() {
      return {
        firstItemClass: 'queue-item__detail--first-item'
      }
    },
    computed: {
      innerClasses: function() {
        return this.classes.join(' ');
      }
    },
    methods: {
      handleClick (event, id) {
        this.$emit('handle-click', { event: event, id: id });
      },
      hideComment () {
        this.$emit('hide-comment');
      },
      slug(string) {
        return lodash.kebabCase(string);
      },
      ucfirst(string) {
        return lodash.upperFirst(string);
      },
    },
  }
</script>

<style lang="scss" scoped>
  .queue-item {
    background:$white;
    border: 1px solid $dark-silver;
    border-radius:em(3px);
    transition:.2s;
    display: flex;
    padding:em(1px);
    margin-top: em(10px);
    &:hover {
      border:1px solid $curiouser-blue;
      box-shadow: 0 em(1px) em(3px) 0 rgba(17, 118, 187, 0.35);
      cursor:pointer;
      transition:.2s;
      .queue-item--hoverable {
        background: $selago;
      }
    }
    @include m(no-hover) {
      &:hover {
        border:1px solid $alto;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.35);
        cursor:default;
        transition:.2s;
      }
    }
    @include m(no-shadow) {
      box-shadow:none;
      &:hover {
        box-shadow:none;
      }
    }
    @include e(detail) {
      border-left:1px solid $quicksilver;
      padding: 0.625em;
      &:first-of-type {
        border-left:none;
      }
      @include m(flex-container) {
        display:flex;
        flex-direction:row;
        justify-content:space-around;
      }
    }
  }
</style>
